import { render, staticRenderFns } from "./DeliverOrder.vue?vue&type=template&id=2f24b038&scoped=true&"
import script from "./DeliverOrder.vue?vue&type=script&lang=js&"
export * from "./DeliverOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24b038",
  null
  
)

export default component.exports